<template>
<div  class="container-fluid" >

<div class="card text-white">
  
<div class="card-header bg-primary">    
  <h4><i  class="fas fa-list-alt mr-2" aria-hidden="true"></i>STOCK MATCHING</h4>    
</div>

<div style="color:black" class="card-body"> 

<div class="row">

  <div v-if="type=='A'">
  <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <div class="card border-info" >
  <div class="card-header bg-info"><strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body ">

  <form name="productSearch" v-on:submit.prevent="getData()">
            
      <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>
      <supplier-brand-list :key="refresh"  v-bind:props="brand" @update="setBrandId"></supplier-brand-list>        
           
      <year-select  v-bind:props="season_year" @update="setYear"></year-select>
      <season-select v-bind:props="season"  @update="setSeasonId"></season-select>
      <department-select v-bind:props="department" @update="setDepartmentId"></department-select>
      <category-grouping v-bind:props="catGrouping" @update="setGroupCategoryId"></category-grouping>  
            
      <button  class="btn btn-primary active float-right ">
        <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
        CERCA
        <span v-if="spinner" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
      </button>
  
  </form>

  </div>
  </div>

    

</div>
<div class="col" v-else>

<button  @click="refreshData()"  class="btn btn-secondary  ml-1 mb-1">
   <i  class="fas fa-reply mr-2" aria-hidden="true"></i>
   RITORNA A RICERCA CAMPIONE PRODOTTI
</button>

<button type="button" class="btn btn-success ml-3" @click="openBarcodeScan()" data-toggle="modal" data-target="#scan">
  APRI INPUT SCANSIONE 
</button>

<input-file class="mt-1 mb-1" @update="getDataFromFile" v-bind:type="'stockMatching'"></input-file> 

<alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

         <p style="color:red;font-size:18px" v-if="items.length>0" class="text-center "><strong>
      <i class="fas fa-barcode mr-2" aria-hidden="true"></i>
     PRONTO ALLA SCANSIONE</strong></p>  
<!--<button type="button" class="btn btn-success">{{btn_text}}</button>-->     

<div >
<h4 style="color:brown;font-weight: bolder;">{{product.supplier }} {{product.brand }} {{!product.catGrouping ? '': product.catGrouping }} {{product.department }} {{product.season }} {{product.SeasonYear }}</h4> 
</div>



<!-- Modal -->
<div class="modal" id="scan" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header  border-primary">
        <h5 class="modal-title" id="exampleModalLabel">SCANSIONE BARCODE</h5>
        <button type="button" class="close" @click="closeBarcodeScan()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form v-on:submit.prevent="setBarcode()">
          <div class="form-group">
            <input  required type="number" class="form-control" id="inputScan"  v-model="barcode">
            <small id="inputHelp" class="form-text">Digita o scansiona un codice a barre prodotto.</small>
          </div>

          <!--<button type="submit" class="btn btn-primary">Submit</button>-->
        </form>
      </div>
      <alert-box class="ml-1 mr-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
      
    </div>
  </div>
</div>


<!--
<form v-on:submit.prevent="setBarcode()">
  
  <div class="form-group">
   
    <input required v-focus type="number" class="form-control"  v-model="barcode">
    <small id="inputHelp" class="form-text">Digita o scansiona un codice a barre prodotto.</small>
  </div>
  <button type="submit" class="btn btn-primary">Submit</button>
</form>
-->


         <div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">

  <table class="table table-hover table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">#</th>
        <th scope="col">ID PRODOTTO</th>
        <th scope="col">BRAND</th>
        <th scope="col">CATEGORIA</th>
        
        <th scope="col">CODICE PRODOTTO</th>
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
     
        <th scope="col">COLORE</th>
        <th scope="col">MISURA</th>
        <th class="text-right" scope="col">QTA' STOCK</th>
        <th class="text-right" scope="col">QTA' MATCH</th>
        <th scope="col">EAN GESTIONALE</th>
       
      </tr>
    </thead>
    <tbody>
      
      <tr  v-bind:style="{backgroundColor : item.match_qty > item.qty   ? 'yellow':'white'}" v-for="(item, index) in items" :key="index">
        <td>{{index+1}}</td>
        <td>{{item.productId}}</td>
        <td>{{item.brand}}</td>
        <td>{{item.category}}</td>        
        <td><strong>{{item.sku}}</strong></td>
        <td>{{item.department}}</td>
        <td>{{item.season}}-{{item.season_year}} </td>
        <td>{{item.color}} </td>
        <td>{{item.size}} </td>        
        
        <td class="text-right"><strong>{{item.qty}}</strong></td>
        <td 
        v-bind:style="{color: item.match_qty != item.qty ? 'red':'black'}" class="text-right"><strong>{{item.match_qty}}</strong></td>
        <td>{{item.barcode}}</td>
       
      </tr> 
      
      
    </tbody>
    <tfoot>
        <tr> 
        <td></td>        
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>        
        <td></td>                
        <td></td>
        <td></td>
        <td class="text-right"> {{total1}}</td>
        <td class="text-right"> {{total2}}</td>
        <td></td>               
        </tr>   
    </tfoot>    
  </table>
    
</div>



<button  @click="set_sandBox()"  class="btn btn-outline-secondary mt-2 ml-2 mr-3">
   <i  class="far fa-copy mr-2" aria-hidden="true"></i>
   SOSPENDI OPERAZIONI
</button>
<button  @click="get_sandBox()"  class="btn btn-outline-secondary  mt-2">
   <i  class="fas fa-paste mr-2" aria-hidden="true"></i>
   RIPRENDI OPERAZIONI
</button>

</div>

<!-- row-->
</div>

</div>
</div>

</div>



</template>
<script>
import onScan from 'onscan.js'
//import scannerDetection    from '@/scanner';  
import api                 from "@/api";

import alertBox          from '@/components/common/AlertBox.vue'

import supplierSelect    from '@/components/common/SupplierSelect_1.vue';
import categoryGrouping  from '@/components/common/CategoryGroupingSelect_1.vue';

import departmentSelect  from '@/components/common/DepartmentSelect_1.vue';
import seasonSelect      from '@/components/common/SeasonSelect_1.vue';
import yearSelect        from '@/components/common/YearSelect_1.vue';

import supplierBrandList from '@/components/common/SupplierBrandSelect_1.vue'
import inputFile         from '@/components/common/InputFile.vue';

import {mapGetters }    from 'vuex';
export default {
   //props      : ['route'],
  components  : {alertBox,supplierSelect,categoryGrouping,departmentSelect,seasonSelect,yearSelect,supplierBrandList,inputFile},
  data() {
    return {
    
    brand           :
      {
        Id            : '%',
        required      : false,
        allBrands     : true,
        supplierId    : 0

      },  
    type                   : 'A',
    product                : {},
    supplier        : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
     department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
       
      },
     season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : true,
        type          : true


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : true

      },
      catGrouping     : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },      
    items                  : [],
    barcode                : '',
    msg                    : {
        title : '',
        body  : '',
        type  : 0
      },
    spinner                : false,     
    total1                 : 0,
    total2                 : 0,
    refresh                : 100
      
    
     
    }
  },
  computed :{
   
     ...mapGetters(['storeId']),
    
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
   mounted : function()
  {


this.initScan()






    
    /*
    $(document).scannerDetection(data => 
    {
      onReceive:
      this.msg.title = ''
      if(this.items.length==0)
      {
        this.msg.title = "ATTENZIONE "
        this.msg.body  = "Selezionare un campione di prodotti."
        this.msg.type  = 1
        
        return
      }

      onComplete:
      if (data.length == 13)
      { 

        this.setMatch(data)

      };       
    });
    */
    
  },
  beforeDestroy () {
   onScan.detachFrom(document);
  
        //$(document).scannerDetection(false);
    },
  

  created: function() {
    


  },
  methods: {
    
    getDataFromFile(barcodes)
    {
      
      barcodes.forEach(item=>{
        this.setBarcodeFromFile(item.barcode)
      })
    },
    refreshData()
    {
      this.product = {}
      this.type ='A'
      this.msg.title = ''
      this.items=[]
      this.total2 = 0
      this.brand.supplierId = 0
      this.brand.Id = '%'
      this.refresh++
    },
    setBrandId(brandId)
    {
            
      this.brand.Id = brandId 
      this.product.brand = ''
      if(brandId != '%')
      {
        this.product.brand = brandId
      }

    },
    openBarcodeScan()
    {
      onScan.detachFrom(document);
      $('#scan').on('shown.bs.modal', function () {
      $('#inputScan').trigger('focus')
      })
    },
    closeBarcodeScan()
    {
      this.initScan()
    },

    initScan()
    {
      onScan.attachTo(document, 
      {
      suffixKeyCodes: [13], // enter-key expected at the end of a scan
      reactToPaste: true, // Compatibility to built-in scanners in paste-mode (as opposed to keyboard-mode)

      onScan : (sCode, iQty) =>  { // Alternative to document.addEventListener('scan')
        this.msg.title = ''
        if(this.items.length==0)
        {
          this.msg.title = "ATTENZIONE "
          this.msg.body  = "Selezionare un campione di prodotti."
          this.msg.type  = 1
        
          return
        }
        this.setMatch(sCode)
        //alert('Scanned: ' + iQty + 'x ' + sCode)
        console.log('Scanned: ' + iQty + 'x ' + sCode); 
    },
    
    
    onKeyDetect: function(iKeyCode){ // output all potentially relevant key events - great for debugging!
        console.log('Pressed: ' + iKeyCode);
    }
    
})
    },
    set_sandBox()
    {      
      if(this.items.length > 0)
      {
       
        localStorage.setItem('stock_matching',JSON.stringify(this.items))
        this.items = []


      }
        
    },
    get_sandBox()
    {
        const items = JSON.parse(localStorage.getItem('stock_matching'))
        if(items)
        {
         
            
          this.items = items
          
        }
        
    },
    check()
    {
      
      let arr = this.items.filter(item => item.qty != item.match_qty)

    },
    setTotal2()
    {
       let total= 0
       this.items.forEach(item=>
          total += Number(item.match_qty)
       )
       this.total2 = total
    },
    setMatch(barcode)
    {
      
      let arr = this.items.filter(item => item.barcode == barcode)
      
      if(arr.length==0)
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Articolo non presente sul campione prodotti.'
        this.msg.type = 1
        return
      }
      let index = arr[0].row_index
      this.items[index-1].match_qty++
      this.setTotal2()

    }, 

    setBarcodeFromFile(barcode)
    {
      
      let arr = this.items.filter(item => item.barcode == barcode)
      
      if(arr.length==0)
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Articolo non presente sul campione prodotti.'
        this.msg.type = 1
        
        return
      }

      
      let index = arr[0].row_index
      this.items[index-1].match_qty++
      this.setTotal2()

    },

    setBarcode()
    {
      
      let arr = this.items.filter(item => item.barcode == this.barcode)
      this.barcode = ''
      if(arr.length==0)
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Articolo non presente sul campione prodotti.'
        this.msg.type = 1
        
        return
      }

      
      let index = arr[0].row_index
      this.items[index-1].match_qty++
      this.setTotal2()

    },   
    setSupplierId(Id,text)
    {
      
        this.product.SupplierId = Id
        this.product.supplier =  text  
        this.brand.supplierId = Id
        this.refresh++
    },
    setGroupCategoryId(Id,e)
    {
      
        this.product.GroupCategoryId = Id
         this.product.catGrouping =  e.target.options[e.target.options.selectedIndex].text 
    },
    setCategoryId(Id)
    {
      
        this.product.CategoryId = Id
    },
    setDepartmentId(Id,e)
    {
      
        this.product.DepartmentId = Id
         this.product.department =  e.target.options[e.target.options.selectedIndex].text 
    },
    setSeasonId(Id,e)
    {
      
        this.product.SeasonId = Id
        this.product.season =  e.target.options[e.target.options.selectedIndex].text 

    },
    setYear(year)
    {

        this.product.SeasonYear = year

         
    },

    async getData() {
    
  
      this.msg.title = ''

     
      
      this.total = 0
      this.spinner = true
      this.items   = []
      
      var data     = {
      
      'brand'        : this.brand.Id, 
      'storeId'      : this.storeId,     
      'seasonId'     : this.product.SeasonId,
      'departmentId' : this.product.DepartmentId,
      'year'         : this.product.SeasonYear,
      'grpcategory'  : this.product.GroupCategoryId,
      'supplierId'   : this.product.SupplierId

      } 
      
      
      var sp = {'sp':'spStoreStockMatching'}
      var json    = Object.assign(data, sp)
      console.log(json)
         await api.post(json).then(res => {
          
          
          if(res.status==200)
            {
              
              this.items     = res.data.recordsets[0]
              this.total1 = 0
              this.items.forEach(item=>{
                this.total1 += item.qty
              })
              

              if(res.data.recordsets[0].length==0)
              { 
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = 'DATI INESISTENTI.'
              this.msg.type  = 1
              return
              }
              this.msg.title = ''
              this.type = 'B'
            }
            else if (res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      

      })
      
      this.spinner = false
      






     



    }
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 600px;
overflow: auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  hwb(45 4% 9%);
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }


 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 18px;
    background   : whitesmoke;
    color        : green;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
  
}
tr {
  font-family: 'Roboto Condensed';
}
.card-header
{
  height: 45px;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}
</style>